export const FILTER_DRAWER_BUTTON_ID = 'facet-drawer-button';
